import { render, staticRenderFns } from "./ItsSalesFeeDetail.vue?vue&type=template&id=2eaf8711&scoped=true&"
import script from "./ItsSalesFeeDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesFeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesFeeDetail.vue?vue&type=style&index=0&id=2eaf8711&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaf8711",
  null
  
)

export default component.exports